import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Button } from 'react-bootstrap';
import Icon from 'modules/react/components/stateless/Icon';
import { Hyper } from '../../../../layout';
import EventModal from './EventModal';
import EventTable from './EventTable';
import classes from './Events.scss';

export default class Events extends React.Component {
  static propTypes = {
    events: PropTypes.array,
    event: PropTypes.object,
    modalEventId: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    loadEvents: PropTypes.func.isRequired,
    loadEvent: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired,
  };

  handleModalShow = (eventId) => {
    const { showModal, loadEvent } = this.props;
    loadEvent(eventId);
    showModal(eventId);
  };

  renderEventTable() {
    const { events } = this.props;

    if (!events) {
      return 'Loading...';
    }

    return (
      <EventTable
        events={events}
        onModalShow={this.handleModalShow}
      />
    );
  }

  renderEventModal() {
    const { modalEventId, hideModal, event } = this.props;

    if (!modalEventId) {
      return false;
    }

    return (
      <EventModal
        onClose={hideModal}
        event={event}
      />
    );
  }

  render() {
    const { isLoading, loadEvents } = this.props;

    return (
      <Hyper title="Log of changes made to this site" activeItem="papertrail">
        <Helmet title="Event Log" />

        <div className={classes.container}>
          <div className="pull-right">
            <Button variant="primary" onClick={loadEvents} disabled={isLoading}>
              <Icon id="sync" label="Refresh Button" />
              {' '}
              Refresh{isLoading ? 'ing...' : ''}
            </Button>
          </div>
          {this.renderEventTable()}
        </div>
        {this.renderEventModal()}
      </Hyper>
    );
  }
}
